import * as React from "react";
import { forwardRef } from "react";
const PlayCircleIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12 4.485a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 1 0 0-16.5zm-9.75 8.25c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75-9.75-4.365-9.75-9.75zm8.25-2.475v4.951l4.456-2.475L10.5 10.26zM9 9.623c0-.858.922-1.4 1.671-.983l5.603 3.113a1.126 1.126 0 0 1 0 1.967l-5.603 3.113A1.125 1.125 0 0 1 9 15.85V9.623z"
}));
const ForwardRef = forwardRef(PlayCircleIcon);
export default ForwardRef;